import type { AuthResponse } from '@/features/auth/api';

export const AUTH_DATA_QUERY_KEY = 'auth:user';

// Requests can outlive their hook owner, so read the shared session at completion too.
export function getStoredAuth(): AuthResponse | null {
    try {
        const value: unknown = JSON.parse(localStorage.getItem(AUTH_DATA_QUERY_KEY) ?? 'null');
        if (!value || typeof value !== 'object') return null;
        if (!('accessToken' in value) || typeof value.accessToken !== 'string' ||
            !('refreshToken' in value) || typeof value.refreshToken !== 'string' ||
            !('accessTokenExpiresAt' in value) || typeof value.accessTokenExpiresAt !== 'string' ||
            !('tokenType' in value) || typeof value.tokenType !== 'string') return null;
        return value as AuthResponse;
    } catch {
        return null;
    }
}
